import DomainModel from './DomainModel'

class DelayPercentage extends DomainModel {
  constructor(
    private id: string,
    private initialDelayPercentage: number,
    private generationDelayPercentage: number,
    private allocationDelayPercentage: number,
    private finishInvestigationDelayPercentage: number,
    private initialClosureDelayPercentage: number,
    private finalClosureDelayPercentage: number,
    private qcDelayPercentage: number,
    private missedInitiationDelayPercentage: number = 150
  ) {
    super()
  }

  getId = () => this.id
  getInitialDelayPercentage = () => this.initialDelayPercentage
  getMissedInitiationDelayPercentage = () => this.missedInitiationDelayPercentage
  getGenerationDelayPercentage = () => this.generationDelayPercentage
  getAllocationDelayPercentage = () => this.allocationDelayPercentage
  getFinishInvestigationDelayPercentage = () => this.finishInvestigationDelayPercentage
  getInitialClosureDelayPercentage = () => this.initialClosureDelayPercentage
  getFinalClosureDelayPercentage = () => this.finalClosureDelayPercentage
  getQcDelayPercentage = () => this.qcDelayPercentage
}

export default DelayPercentage
